<template>
  <div>
    <v-layout>
      <v-text-field :label="$t('Vehicle')" @blur="codeControl()" :placeholder="kodmesajı" append-icon="search"
        @click:append="dialogac()" :tabindex="tabdeger" v-model="val" hide-details=""></v-text-field>
    </v-layout>
    <v-dialog scrollable="" v-model="dialog" max-width="550px">
      <v-card color="grey lighten-2">
        <v-toolbar size="120px" color="info">
          <v-toolbar-title class="white--text">{{$t('Vehicle-Field-List')}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field solo hide-details ref="ara" autofocus="" v-model="aranandeger" :label="this.$t('Search')"
            append-icon="search"></v-text-field>
        </v-toolbar>
        <v-card-text>
          <v-layout row="" wrap="">
            <div class="flex md12">
              <v-data-table :headers="headersservis" :search="aranandeger" :loading="progress" :items="listitems" hide-actions
                class="elevation-1">
                <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                <template slot="items" slot-scope="props">
                  <tr @click="kabul(props.item)" item>
                    <td class="text-xs-left">{{ props.item.AnaTip }}</td>
                    <td class="text-xs-left">{{ props.item.AltTip }}</td>
                      <td class="text-xs-left">{{ props.item.AracAdi }}</td>
                    <td class="justify-center layout px-0">
                    </td>
                  </tr>
                </template>
                  <v-alert slot="no-results" :value="true" color="error" icon="warning">
                    {{ $t('No-records-searched-for', { value: aranandeger}) }}
                  </v-alert>
              </v-data-table>

            </div>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">
            {{$t("cancel_button")}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import tool from "../tools";

  export default {
    props: ["value", "tabdeger","saticikodu"],
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },


    beforeMount: beforeMount,
    methods: {
      kayitgetir: kayitgetir,
      dialogac: dialogac,
      kabul: kabul,
      codeControl: codeControl
    },
    data() {
      return {
        headersservis: [{
            text: this.$t('Type'),
            value: 'AnaTip'
          },
          {
            text: this.$t('Sub-Type'),
            value: 'AltTip',

          },
           {
            text: this.$t('Vehicle-Name'),
            value: 'AracAdi',

          }

        ],
        kodmesajı: null,
        progress: false,
        listitems: [],
        aranacakkelime: null,
        aranandeger: null,
        dialog: false,

        text1: null,
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },

    watch: {
    //  secilendeger(val) {
       /// val && this.kayitgetir(val)
     // },

      dialog(val2) {
        if (!val2) return
        requestAnimationFrame(() => {
          this.$refs.ara.focus()
        })
      }

    },
  }

  function codeControl() {


  }


  function kabul(m) {
    this.val = m.AnaTip
    this.dialog = false
  }

  function dialogac() {
    this.dialog = true

 var params = {
 SaticiKodu:this.saticikodu

    }
    tool.http_post(this, "AracAlanAra", params).then(
      response => {

        if (response.body.Status == true) {

          this.listitems = response.body.data
        } else {

          this.text1 = response.body.ErrorList[0]
          this.snackbar = true
        }
      },
      response => {

        this.text1 = 'Service Unavailable-TasimaTipleriAra'
        this.snackbar = true
      }
    );

  }

  function beforeMount() {


  }

  function kayitgetir(y) {

    if (y != null) {

      if (y.length > 0) {

        this.progress = true



        var params = {
          Kod: null,
          Tip: null,
          Aciklama: null,
          Bolge: null,
          Nerden: null,
          Nereye: null,
          ADT: null,
        }
        tool.http_post(this, "TasimaTipleriAra", params).then(
          response => {

            if (response.body.Status == true) {

              this.aractipitems = response.body.data


            } else {

              this.text1 = 'Service Unavailable-TasimaFiyatKalemTipArama'
              this.snackbar = true
            }
          },
          response => {

            this.text1 = 'Service Unavailable-TasimaFiyatKalemTipArama'
            this.snackbar = true
          }
        );
      } else {
        this.listitems = []
        this.progress = false
      }

    }
  }
</script>